import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './components/Toast';
import Login        from './pages/Login';
import Dashboard    from './pages/Dashboard';
import Organizations from './pages/Organizations';
import Users        from './pages/Users';
import Logs         from './pages/Logs';
import Sidebar      from './components/Sidebar';
import { FiMenu, FiZap } from 'react-icons/fi';

// Applique le dark mode automatiquement (préférence système)
if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    document.documentElement.classList.add('dark');
}

const Layout = ({ children }) => {
    const [mobileOpen, setMobileOpen] = useState(false);

    return (
        <div className="flex h-screen bg-gray-50 dark:bg-gray-950 overflow-hidden">
            <Sidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
            <div className="flex-1 flex flex-col overflow-hidden min-w-0">
                {/* Barre de navigation mobile */}
                <header className="md:hidden flex items-center h-14 px-4 bg-gray-900 border-b border-gray-800 shrink-0">
                    <button
                        onClick={() => setMobileOpen(true)}
                        className="p-2 rounded-lg text-gray-400 hover:text-white hover:bg-gray-800 transition-colors"
                        aria-label="Ouvrir le menu"
                    >
                        <FiMenu size={20} />
                    </button>
                    <div className="flex items-center gap-2 ml-3">
                        <div className="w-6 h-6 rounded-md bg-brand-600 flex items-center justify-center">
                            <FiZap size={12} className="text-white" />
                        </div>
                        <span className="text-white font-bold text-sm">PulseCIO</span>
                        <span className="text-brand-400 text-xs font-semibold">Admin</span>
                    </div>
                </header>
                <main className="flex-1 overflow-y-auto">
                    {children}
                </main>
            </div>
        </div>
    );
};

const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();
    if (loading) return (
        <div className="h-screen flex items-center justify-center bg-gray-950">
            <div className="w-8 h-8 border-2 border-brand-500 border-t-transparent rounded-full animate-spin" />
        </div>
    );
    if (!user) return <Navigate to="/login" replace />;
    return <Layout>{children}</Layout>;
};

const PublicRoute = ({ children }) => {
    const { user, loading } = useAuth();
    if (loading) return null;
    if (user) return <Navigate to="/" replace />;
    return children;
};

const App = () => (
    <ToastProvider>
    <AuthProvider>
        <BrowserRouter>
            <Routes>
                <Route path="/login"          element={<PublicRoute><Login /></PublicRoute>} />
                <Route path="/"           element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/orgs"       element={<ProtectedRoute><Organizations /></ProtectedRoute>} />
                <Route path="/users"      element={<ProtectedRoute><Users /></ProtectedRoute>} />
                <Route path="/logs"       element={<ProtectedRoute><Logs /></ProtectedRoute>} />
                <Route path="*"           element={<Navigate to="/" replace />} />
            </Routes>
        </BrowserRouter>
    </AuthProvider>
    </ToastProvider>
);

export default App;
